/**
 * Client helpers for /api/remodel/leads.
 *
 * The form and any future dashboard/widget go through this module — nothing
 * else should build a remodel-lead URL by hand.
 */
const BASE = "/api/remodel/leads";

const asJson = async (response) => {
  if (!response.ok) {
    let message = `Request failed (${response.status})`;
    try {
      const body = await response.json();
      if (body?.message) message = body.message;
    } catch (err) {
      // Non-JSON error body; the status is all we have.
    }
    throw new Error(message);
  }
  return response.json();
};

/** Submit a new remodel lead; `user` is the logged-in submitter. */
export const submitRemodelLead = async (values, user) =>
  fetch(BASE, {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ ...values, user: user || {} }),
  }).then(asJson);

/** List leads — pass an email to get just that submitter's (My Submissions). */
export const fetchRemodelLeads = async (email) =>
  fetch(
    email ? `${BASE}?email=${encodeURIComponent(email)}` : BASE
  ).then(asJson);

/** URL of a lead's printable PDF. */
export const remodelLeadPdfUrl = (id) => `${BASE}/${id}/pdf`;
